import { Tooltip as ReactTooltip } from 'react-tooltip';
import { VariantProps } from 'tailwind-variants';
import { cn } from '@Utils';

import { badgeVariants } from './variants';

const buildTooltip = ({ id, content }: { id: string; content: string }) => {
  return <ReactTooltip id={id} positionStrategy="fixed" place="top" content={content} offset={18} />;
};

export interface BadgeProps extends VariantProps<typeof badgeVariants> {
  label: string;
  showDot?: boolean;
  icon?: React.ReactNode;
  tooltipId?: string;
  toolInfo?: string;
  className?: string;
}

const Badge = ({ label, showDot = false, icon, tooltipId, toolInfo, variant, className }: BadgeProps) => {
  const { base, dot, icon: iconClass } = badgeVariants({ variant });

  return (
    <>
      <div data-tooltip-id={tooltipId} className={cn(base(), className)}>
        {showDot && <div className={dot()} />}
        <span className="text-center">{label}</span>
        {icon && <div className={iconClass()}>{icon}</div>}
      </div>

      {toolInfo && tooltipId && buildTooltip({ id: tooltipId, content: toolInfo })}
    </>
  );
};

export default Badge;
